import Phaser from "phaser";
import { Button } from "@ravalmatic/catafractum-utils";
import { GameManager } from "../../../GameManager";
import { Preferences } from "../../../Preferences";

export class BurgerMenu extends Phaser.GameObjects.Container {
    private static readonly SPACING = 92;
    private static readonly VERTICAL_OFFSET = 12;

    private settingsBtn: Button;
    private musicOnBtn: Button;
    private musicOffBtn: Button;
    private sfxOnBtn: Button;
    private sfxOffBtn: Button;
    private infoBtn: Button;
    private resetBtn: Button;
    private homeBtn: Button;
    private menuItems: Button[];
    private isOpen = false;

    constructor(scene: Phaser.Scene) {
        super(scene);
        this.resetBtn = this.createButton(scene, "btn_reset", () => GameManager.enterBoardScene());
        this.infoBtn = this.createButton(scene, "btn_info", () => {
            this.closeMenu();
            console.log("BurgerMenu: info");
        });
        this.homeBtn = this.createButton(scene, "btn_home", () => GameManager.enterSplashScene());
        this.musicOnBtn = this.createButton(scene, "btn_soundtrack_on", () => console.log("BurgerMenu: music"));
        this.musicOffBtn = this.createButton(scene, "btn_soundtrack_off", () => console.log("BurgerMenu: music"));
        this.sfxOnBtn = this.createButton(scene, "btn_sfx_on", () => console.log("BurgerMenu: sfx"));
        this.sfxOffBtn = this.createButton(scene, "btn_sfx_off", () => console.log("BurgerMenu: sfx"));
        this.settingsBtn = new Button(scene, 0, 0, "texture_atlas_1", "btn_settings");
        this.settingsBtn.setInflationTween(1.05);
        this.settingsBtn.on("pointerup", this.toggle, this);
        this.menuItems = [this.musicOnBtn, this.sfxOnBtn, this.infoBtn, this.resetBtn, this.homeBtn];
        this.add(this.menuItems);
        this.add([this.musicOffBtn, this.sfxOffBtn, this.settingsBtn]);
        this.bringToTop(this.settingsBtn);
        this.refreshAudioButtons();
    }

    private createButton(scene: Phaser.Scene, frame: string, callback: () => void): Button {
        const button = new Button(scene, 0, 0, "texture_atlas_1", frame);
        button.setInflationTween(1.05);
        button.setVisible(false);
        button.disableInteractive();
        button.onUp(callback, this);
        return button;
    }

    private toggle(): void {
        console.log("BurgerMenu: settings");
        this.isOpen ? this.closeMenu() : this.openMenu();
    }

    public isMenuOpen(): boolean {
        return this.isOpen;
    }

    private openMenu(): void {
        this.isOpen = true;
        this.menuItems.forEach((button, index) => {
            const variants = this.getVariants(button);
            this.scene.tweens.killTweensOf(variants);
            variants.forEach(variant => {
                variant.y = 0;
                variant.setVisible(true);
                variant.setInteractive();
            });
            this.scene.tweens.add({
                targets: variants,
                y: (index + 1) * BurgerMenu.SPACING + BurgerMenu.VERTICAL_OFFSET,
                ease: Phaser.Math.Easing.Back.Out,
                duration: 300,
                delay: index * 50
            });
        });
        this.refreshAudioButtons();
    }

    private closeMenu(): void {
        this.isOpen = false;
        this.menuItems.forEach(button => {
            const variants = this.getVariants(button);
            this.scene.tweens.killTweensOf(variants);
            variants.forEach(variant => variant.disableInteractive());
            this.scene.tweens.add({
                targets: variants, y: 0, ease: Phaser.Math.Easing.Cubic.In, duration: 200,
                onComplete: () => variants.forEach(variant => variant.setVisible(false))
            });
        });
    }

    private refreshAudioButtons(): void {
        const states: [Button, boolean][] = [
            [this.musicOnBtn, !Preferences.musicMuted], [this.musicOffBtn, Preferences.musicMuted],
            [this.sfxOnBtn, !Preferences.sfxMuted], [this.sfxOffBtn, Preferences.sfxMuted]
        ];
        states.forEach(([button, enabled]) => {
            const visible = this.isOpen && enabled;
            button.setVisible(visible);
            if (visible) button.setInteractive();
            else button.disableInteractive();
        });
    }

    private getVariants(button: Button): Button[] {
        if (button === this.musicOnBtn) return [this.musicOnBtn, this.musicOffBtn];
        if (button === this.sfxOnBtn) return [this.sfxOnBtn, this.sfxOffBtn];
        return [button];
    }
}
